import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getUserFromToken } from "../utils/apiUtils";

/**
 * Organization Admin Protected Route Component
 * Checks if user is authenticated and has BitNetOrgAdmin role
 * CRITICAL: BitNetOrgAdmin can ONLY access /clients and /client-monitoring routes
 * All other routes redirect to /clients
 * @param {Object} props - Component props
 * @param {React.Component} props.children - Child components to render if authorized
 * @returns {React.Component} Children or redirect to login/clients
 */
const OrgAdminProtectedRoute = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  // Allowed paths for BitNetOrgAdmin
  const allowedPaths = ["/", "/clients", "/monitoring", "/client-monitoring"];

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Decode user from token
  const user = getUserFromToken();

  if (!user) {
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // Check if user has BitNetOrgAdmin role
  if (user.role !== "BitNetOrgAdmin") {
    console.warn("Access denied: User does not have BitNetOrgAdmin role");
    return <Navigate to="/login" replace />;
  }

  // CRITICAL: BitNetOrgAdmin can ONLY access allowed paths
  if (!allowedPaths.includes(location.pathname)) {
    console.warn(`BitNetOrgAdmin attempting to access unauthorized route: ${location.pathname}`);
    return <Navigate to="/clients" replace />;
  }

  return <Outlet />;
};

export default OrgAdminProtectedRoute;
